export default __webpack_public_path__ + "static/feature-seal-813adc2172cf5e485c0b5c487723b0f3.png";